module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PayTipView.js"));
	}, "PayTipView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PayTipView!./src/pages/Shop/PayMent/PayTip/PayTipView.js
// module id = 873
// module chunks = 438